import { DROP_WORD_CONFIG } from '../constants/game'
import WordComponent from './word'

export default class DropWord {
  /** @type Phaser.GameObjects.Container */
  word

  /**
   * @type {{
   *  context: Phaser.Scene,
   *  data: {
   *   x: number,
   *   y: number,
   *   word: string,
   *   isLocked: boolean,
   *   lockedSrc: string,
   *   dragSrc: string,
   *   emptySrc: string,
   *   index: number,
   *   lockedSrcKey: string,
   *   emptySrcKey: string
   *  }
   * }}
   **/
  config = {}

  /**
   *
   * @param {Phaser.Scene} context
   * @param {{
   *  x: number,
   *  y: number,
   *  word: string,
   *  isLocked: boolean,
   *  lockedSrc: string,
   *  dragSrc: string,
   *  emptySrc: string
   *  lockedSrcKey: string,
   *  emptySrcKey: string
   * }} word
   * @param {number} index
   */
  constructor(context, word, index) {
    this.config.context = context
    this.config.data = { ...word, index }
    this.wordComp = null;
    this.drawOnContext();
  }

  drawOnContext() {
    const wordComp = new WordComponent(this.config.context, this.config.data.word);
    wordComp.blankState();
    this.wordComp = wordComp;
    // LETS DO DROP ZONE A LITTLE BIT HIGHER (1.5)
    var dropZone = this.config.context.add.zone(0, 0,
      wordComp.width, wordComp.height * 1.5)
      .setRectangleDropZone(wordComp.width, wordComp.height)
      .setOrigin(0)
      .setScrollFactor(0)
      .setDepth(DROP_WORD_CONFIG.depth + 1);

    wordComp.container.add(dropZone);
    this.word = wordComp.container
    this.word.width = wordComp.width

    // this.word = wordComp.container;
    //  this.word.controller = wordComp; 
    wordComp.container.x = this.config.data.x;
    wordComp.container.y = this.config.data.y;
    wordComp.container.setDepth(DROP_WORD_CONFIG.depth)
      .setScrollFactor(0).cameraFilter = this.config.context.cameras.getCamera('minimap').id
    if (this.config.data.isLocked) return

    this.word.cameraFilter = this.config.context.cameras.getCamera('minimap').id

    dropZone.setDataEnabled()
    dropZone.setData({
      ...this.config.data,
      word: this.config.data.word,
      isDropped: false,
      hover: false
    });
    dropZone.on(
      'changedata',
      (word, dataKey, newValue, prevValue) => {
        if (dataKey === "isDropped" && newValue === true) {

          wordComp.dropedState();
          //word.setTexture(this.config.data.lockedSrcKey)
        }
        if (dataKey === "hover") {
          wordComp.highlight(newValue);
        }
      },
      this
    )


  }

  blinkSuccess() {
   
      this.wordComp.blinkState();
   
  }
}
